import { useState } from 'react'
import {
    Container,
    MainContentWrapper,
    MainContent,
    Heading,
    UploadButton
} from '../../styles/account/account'
import { DashboardWrapper } from '../../container/dashboardWrapper'
import { Breadcrumb } from '../../components/breadcrumb/breadcrumb'
import { Input } from '../../components/input'
import { InputWrapper } from '../../components/input/input.style'
import { Button } from '../../components/button'
import { AssignmentInputButtonContainer } from '../../styles/assignment/assignment'
import { Textarea } from '../../components/textarea/textarea'

const AssignmentSubmit = () => {
    const [imageUploadValue, setImageUploadValue] = useState('')

    const handleImageUploadValue = (e) => {
        const file = e.target.files[0]
        setImageUploadValue(file.name)
    }
    return (
        <DashboardWrapper>
            <MainContentWrapper fullHeight>
                <Container>
                    <MainContent>
                        <Heading>
                            Submit Assignment
                        </Heading>
                        <Breadcrumb
                            crumbs={['Assignments', "Submit"]}
                        />
                        <form>
                            <InputWrapper>
                                <Input
                                    id="assignmentTitle"
                                    label="ASSIGNMENT TITLE"
                                    type="text"
                                    placeholder="English Assignment"
                                    fullWidth
                                />
                            </InputWrapper>
                            <InputWrapper>
                                <Textarea
                                    id="assignmentDescription"
                                    label="DESCRIPTION"
                                    type="text"
                                    placeholder="Description"
                                    fullWidth
                                />
                            </InputWrapper>
                            <InputWrapper>
                                <AssignmentInputButtonContainer >
                                    <Input value={imageUploadValue} fullWidth type='text' placeholder="Choose file" style={{ height: '42px' }} />
                                    <label htmlFor="contained-button-file">
                                        <input onChange={handleImageUploadValue} accept="image/*" id="contained-button-file" multiple type="file" style={{ display: 'none' }} />
                                        <UploadButton variant="contained" component="span"
                                            disableElevation
                                            color="primary"
                                        >
                                            BROWSE
                                        </UploadButton>
                                    </label>
                                </AssignmentInputButtonContainer>
                            </InputWrapper>
                            <div style={{ marginLeft: 'auto', marginTop: '8rem' }}>
                                <Button
                                    type="submit"
                                    variant="secondary"
                                    responsive
                                >
                                    submit
                                </Button>
                            </div>

                        </form>
                    </MainContent>
                </Container>
            </MainContentWrapper>
        </DashboardWrapper>
    )
}

export default AssignmentSubmit
